<template>
  <div class="recycle-footer-component">
    <div class="footer">
      <div class="footer-content box">
        <div class="footer-left">
          <div class="footer-left-top">
            <div class="footer-logo-image">
              <img class="icon-footer-logo" src="./img/icon_footer_logo.png" />
            </div>
            <div class="footer-contact-item">
              <img class="icon-footer-call" src="./img/icon_service.png" />
              <div class="call-detail">
                <div>400-661-2099</div>
                <div class="desc">回收宝客服电话</div>
              </div>
            </div>
            <div class="footer-contact-item">
              <img class="icon-footer-call" src="./img/icon_email.png" />
              <div class="call-detail">
                <div>maqiang@huishoubao.com.cn</div>
                <div class="desc">渠道合作</div>
              </div>
            </div>
          </div>
          <div class="footer-left-bottom">
            <span class="copyright" @click="openLicense">Copyright © 2012-2020 深圳回收宝科技有限公司 版权所有 </span>
            <a class="link" rel="nofollow" href="https://beian.miit.gov.cn" target="_blank">粤ICP备14063444号 </a>
            <a class="link" rel="nofollow" href="//www.cnzz.com/stat/website.php?web_id=1254005878" target="_blank">站长统计</a>
          </div>
        </div>
        <div class="footer-right">
          <div>
            <img class="icon-download" src="./img/icon_footer_app_download.png" />
          </div>
          <div>
            <img class="icon-wechatmini" src="./img/icon_footer_wechatmini_ev.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    openLicense () {
      window.open('https://s1.huishoubao.com/static/yyzz/hsb.pdf', '_blank');
    }
  }
};
</script>

<style scoped>
.footer {
  padding: 36px 0;
  background: #2c2c2c;
  .footer-content {
    display: flex;
    align-items: center;
  }
  .footer-left {
    flex: 1;
    overflow: hidden;
    .footer-left-top {
      display: flex;
      align-items: center;
      .footer-logo-image {
        padding-right: 12px;
      }
      .icon-footer-logo {
        width: 167px;
        height: 54px;
      }
      .footer-contact-item {
        display: flex;
        align-items: center;
        margin-left: 30px;
        .icon-footer-call {
          margin-right: 12px;
          width: 40px;
          height: 40px;
        }
        .call-detail {
          font-size: 16px;
          font-weight: bold;
          color: #999999;
          line-height: 22px;
          .desc {
            margin-top: 2px;
            font-size: 12px;
            line-height: 17px;
          }
        }
      }
    }
    .footer-left-bottom {
      margin-top: 24px;
      line-height: 16px;
      font-size: 11px;
      color: #999999;
      .copyright {
        cursor: pointer;
      }
      .link {
        text-decoration: none;
        color: inherit;
      }
    }
  }
  .footer-right {
    display: flex;
    flex-shrink: 0;
    .icon-download, .icon-wechatmini {
      margin-left: 60px;
      width: 120px;
      height: 148px;
    }
  }
}
.box {
  margin: 0 auto;
  width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/components/recycle-footer.vue